// AUTOGENERATED FILE - DO NOT MODIFY!
// This file was generated by Djinni from 101_fatmap_api_window_lifecycle_listener.djinni
export var WindowState;
(function (WindowState) {
    WindowState[WindowState["ACTIVE"] = 0] = "ACTIVE";
    WindowState[WindowState["CREATED"] = 1] = "CREATED";
    WindowState[WindowState["DESTROYED"] = 2] = "DESTROYED";
    WindowState[WindowState["INACTIVE"] = 3] = "INACTIVE";
    WindowState[WindowState["NONE"] = 4] = "NONE";
})(WindowState || (WindowState = {}));
